import React from 'react';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import FieldText from '../../FieldText';
import FieldSelect from '../../FieldSelect';
import FieldAttachment from '../../FieldAttachment';
import FieldDateTime from '../../FieldDateTime';
import FieldLookup from '../../FieldLookup';
import FieldCurrency from '../../FieldCurrency';
import FieldRecordRef from '..';
import FieldNumber from '../../FieldNumber';
import FieldFormula from '../../FieldFormula';
import FieldRating from '../../FieldRating';
import FieldCollaborator from '../../FieldCollaborator';

import { IFieldById, IRecordById } from '../../../../../types/core';
import { ColumnType } from '../../../../../modules/core/graphql/types';
import FieldCheckbox from '../../FieldCheckbox';

interface IProps extends WrappedComponentProps {
  field: IFieldById;
  record: IRecordById;
  showRefAsText: boolean;
  spaceId: string;
  depth?: number;
}

const Content = ({ field, record, depth, spaceId, intl: { formatMessage } }: IProps) => {
  switch (field.type) {
    case ColumnType.TEXT:
    case ColumnType.AUTO_NUMBER:
    case ColumnType.PHONE:
    case ColumnType.EMAIL:
    case ColumnType.ROLLUP:
    case ColumnType.LONG_TEXT:
      return <FieldText.WithFieldId fieldId={field.id} recordId={record.id} />;
    case ColumnType.CHECKBOX:
      return <FieldCheckbox.WithFieldId fieldId={field.id} recordId={record.id} />;
    case ColumnType.RATING:
      return <FieldRating.WithFieldId fieldId={field.id} recordId={record.id} />;
    case ColumnType.FORMULA:
      return <FieldFormula.WithFieldId fieldId={field.id} recordId={record.id} />;
    case ColumnType.CURRENCY:
      return <FieldCurrency.WithFieldId fieldId={field.id} recordId={record.id} />;
    case ColumnType.NUMBER:
      return <FieldNumber.WithFieldId fieldId={field.id} recordId={record.id} />;
    case ColumnType.DATETIME:
    case ColumnType.CREATED_AT:
      return <FieldDateTime.WithFieldId fieldId={field.id} recordId={record.id} />;
    case ColumnType.STATUS:
      return <FieldSelect.StatusWithFieldId fieldId={field.id} recordId={record.id} />;
    case ColumnType.SELECT:
      return <FieldSelect.SingleWithFieldId fieldId={field.id} recordId={record.id} />;
    case ColumnType.MULTI_SELECT:
      return <FieldSelect.MultiWithFieldId fieldId={field.id} recordId={record.id} />;
    case ColumnType.MULTI_ATTACHMENT:
      return (
        <FieldAttachment.TableWithFieldId
          fieldId={field.id}
          recordId={record.id}
          spaceId={spaceId}
        />
      );
    case ColumnType.RECORD_REFERENCE:
      return <FieldRecordRef.TextWithFieldId fieldId={field.id} recordId={record.id} />;
    case ColumnType.SUBTABLE:
      return <FieldRecordRef.TextWithFieldId fieldId={field.id} recordId={record.id} />;
    case ColumnType.LOOKUP:
      return (
        <FieldLookup
          fieldId={field.id}
          recordId={record.id}
          depth={depth}
          isInTable
          showRefAsText
          spaceId={spaceId}
        />
      );
    case ColumnType.COLLABORATOR:
    case ColumnType.CREATED_BY:
      return <FieldCollaborator fieldId={field.id} recordId={record.id} />;
    default:
      return <FieldText.Raw value={formatMessage({ id: 'space.error.unsupported' })} />;
  }
};

export default injectIntl(Content);
